import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import ReceiptReportActions, { ReceiptReportRedux, ReceiptReportTypes } from '../Redux/ReceiptReportRedux'
import { notificationFail } from '../Redux/NotificationActions'

const ReceiptReportCRUDObservable = createCRUDObservable({
  mainRedux: ReceiptReportRedux,
  reduxPath: 'receiptreport',
})

const receiptsEpic = (action$, store, { Api }) =>
  action$.ofType(ReceiptReportTypes.ReceiptReportRequest)
    .mergeMap(({start_date,end_date}) => (
      Observable
        .fromPromise(Api.receiptreport.getReceiptReportExcel(start_date,end_date)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              ReceiptReportActions.ReceiptReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)

          document.body.appendChild(link)
          link.click()
          return [
            ReceiptReportActions.ReceiptReportSuccess(data, fileName),
          ]
        })
    ))

const centersReceiptsEpic = (action$, store, { Api }) =>
  action$.ofType(ReceiptReportTypes.CentersReceiptReportRequest)
    .mergeMap(({start_date,end_date,centerId }) => (
      Observable
        .fromPromise(Api.receiptreport.getCentersReceiptReportExcel(start_date,end_date,centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              ReceiptReportActions.CentersReceiptReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            ReceiptReportActions.CentersReceiptReportSuccess(data, fileName),
          ]
        })
    ))

export const ReceiptReportObservers = Object.assign({}, ReceiptReportCRUDObservable.observers, {})
export const receiptreportEpic = combineEpics(
  ReceiptReportCRUDObservable.epic,
  receiptsEpic,
  centersReceiptsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReceiptReportObservable.js